import { baseApi } from '@/services'
import { IPropertyFlag } from '@/types/unlock'

export const propertyFlagApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listPropertyFlags: builder.query<IPropertyFlag[], string>({
      query: (application_id) => {
        return {
          url: `v2/applications/${application_id}/property-flags/`,
          method: 'GET',
        }
      },
      providesTags: ['PropertyFlag'],
    }),
  }),
})

export const { useListPropertyFlagsQuery } = propertyFlagApi
